import DatePicker from '@vimcar/shared-components/components/DatePicker'
import Icon from '@vimcar/shared-components/components/Icon'
import IconTooltip from '@vimcar/shared-components/components/IconTooltip'
import React from 'react'

import i18n from '../../utils/i18n'
import styles from './styles.css'

type Props = {
  dateFieldProps?: object
  disabled?: boolean
  error?: string | null
  onChange?: (string) => unknown
  onNowClick?: () => unknown
  timeFieldProps?: object
  value?: string | null
}

const tp = i18n.prefixWithoutTestId('components.RouteTrackingControls')

const DateTimeRow = ({
  dateFieldProps,
  disabled,
  error,
  onChange,
  onNowClick,
  timeFieldProps,
  value,
}: Props) => (
  <div className={styles.dateTimeRow}>
    <div className={styles.timeField}>
      <DatePicker
        {...dateFieldProps}
        disabled={disabled}
        onChange={onChange}
        // @ts-expect-error@2322
        underlineDisabledStyle={dateFieldUnderlineDisabledStyle}
        underlineStyle={dateFieldUnderlineStyle}
        value={value}
      />
    </div>
    <div className={styles.timeField}>
      {/* @ts-expect-error@2739 */}
      <DatePicker
        time
        {...timeFieldProps}
        disabled={disabled}
        onChange={onChange}
        value={value}
      />
      {onNowClick && !disabled && (
        <IconTooltip
          className={styles.icon}
          content={tp('set-to-now')}
          icon='get-app'
          iconProps={{ onClick: onNowClick }}
        />
      )}
    </div>
    {error && <div className={styles.error}>{error}</div>}
  </div>
)

const dateFieldUnderlineStyle = { display: 'block' }
const dateFieldUnderlineDisabledStyle = { display: 'none' }

export default DateTimeRow
